import { Autocomplete, Box, Button, FormControl, FormControlLabel, InputLabel, MenuItem, Select, Switch, TextField, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import { ArrowDropDownIcon, DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { ApiDownloadExcel, ApiGetAreaManager, ApiGetMonthlySiteReport, ApiRegionVenues, ApiScoreCardPDF } from '../../apiService/Core/Apicall';
import { RegionList, setRegion } from '../../global/config/Reducer/RegionSlice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../global/config/store';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import Domains from '../../global/constants/domain';
import greendot from '../../assets/common/images/greendot.png'
import reddot from '../../assets/common/images/reddot.png'
import yellowdot from '../../assets/common/images/yellowdot.png'
import { GoogleMap, InfoWindow, LoadScript, Marker } from '@react-google-maps/api';
import { setSelectedMonth } from '../../global/config/Reducer/MonthSlice';
import redlocation from '../../assets/images/red-location.png'
import yellowlocation from '../../assets/images/yellow-location.png'
import greenlocation from '../../assets/images/green-location.png'
import storage from '../../utils/storage';


const getIconColorByDomain = () => {
    const domain = window.location.hostname;

    if (domain.includes(Domains.ALDI)) return '#001F791A';
    if (domain.includes(Domains.BLOOMS)) return '#1A2D8D1A';
    if (domain.includes(Domains.MM)) return '#2ECC711A';

    return '#ADB792';
};

const redDot = () => {
    return (<Box height='10px' width='10px' bgcolor='red'> </Box>)
}
function GroupMonthlySiteScore() {
    const primary_color = getIconColorByDomain()

    const isAldi = window.location.hostname.includes('aldi')

    const selectedMonth = useSelector((state: RootState) => state.month.selectedMonth)
    const [reportyear, setreportyear] = useState<any>(dayjs(selectedMonth))
    const [monthlyreport, setmonthlyreport] = useState<any>([])
    const Regions = useSelector(RegionList)
    const dispatch = useDispatch()
    const [alignment, setAlignment] = React.useState('green');
    const [selectedRegion, setselectedRegion] = useState<number | ''>(Regions[0]?.regionId ?? '')
    const clientEntity = useSelector((state: RootState) => state.clientEntity.selectedEntity)
    const { clientEntityIds } = useSelector((state: RootState) => state.wholegroup)
    const [selectedMarker, setSelectedMarker] = useState<any>(null);
    const [mapsApi, setMapsApi] = useState<any>(null);
    const mapRef = useRef<google.maps.Map | null>(null);
    const isTransport = storage.getItem('ClientGroupName')
    const [isGroupScore, setisGroupScore] = useState<boolean>(false);
    const [colorpalate, setColorPalate] = useState<any>([]);
    const [area, setSelectedArea] = useState<number | string | null>(null)
    const [Areamanagerlist, setareamanagerlist] = useState<any[]>([])


    const handleChange = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: string,
    ) => {
        newAlignment && setAlignment(newAlignment);
    };

    let red = 0
    let yellow = 0
    let green = 0

    useEffect(() => {
        const RegionList = async () => {
            if (storage.getItem("clientEntityId") && storage.getItem('ClientGroupName') === "ALDI") {
                const data = `?clientEntityId=${storage.getItem("clientEntityId")}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`

                const response3 = await ApiRegionVenues(data)
                if((response3?.status || response3?.success) && response3.data?.length > 0){
                dispatch(setRegion(response3.data))
                }
            }
        }
        RegionList()
    }, [clientEntity])

    useEffect(() => {
        if (Regions.length > 0) {
            setselectedRegion(Regions[0].regionId);
        }
    }, [Regions, clientEntity]);

    useEffect(() => {

        const getyearreport = async () => {
            const data = {
                year: reportyear.year(),
                month: reportyear.month() + 1,
                clientEntityId: storage.getItem('clientEntityId'),
                ...(selectedRegion && { regionId: selectedRegion })
            }
            const data2 = `?year=${data.year}&clientGroupName=${storage.getItem('ClientGroupName')}&clientEntityId=${isGroupScore ? clientEntityIds : data.clientEntityId}&month=${data.month}${data.regionId ? `&regionId=${data.regionId}` : ''}${(storage.getItem('areaId') || area) ? `&areaId=${area ?? storage.getItem('areaId')}` : ''}`
            try {
                const response = await ApiGetMonthlySiteReport(data2)
                setmonthlyreport(response.data)
                setColorPalate(response?.colorData)
            }
            catch (error: any) {
                // toast.error(error)
            }
        }
        getyearreport()
    }, [reportyear, selectedRegion, area, clientEntity, isGroupScore])


    const containerStyle = {
        width: '100%',
        height: 'calc(100vh - 310px)'
    };


    const center = useMemo(() => {
        if (!monthlyreport || monthlyreport.length === 0) {
            return { lat: 0, lng: 0 }; // fallback
        }

        const total = (monthlyreport.length > 0) && monthlyreport?.reduce(
            (acc: any, item: any) => {
                const lat = parseFloat(item.lat);
                const lng = parseFloat(item.long);
                return {
                    lat: acc.lat + lat,
                    lng: acc.lng + lng
                };
            },
            { lat: 0, lng: 0 }
        );

        return {
            lat: total.lat / monthlyreport.length,
            lng: total.lng / monthlyreport.length
        };
    }, [monthlyreport, clientEntity]);




    const getMarkerIcon = (score: number) => {
        if (!mapsApi) return undefined;

        return {
            url: score > colorpalate[2]?.minPercentage ? greenlocation : score > colorpalate[1]?.minPercentage ? yellowlocation : redlocation,
            scaledSize: new mapsApi.Size(35, 50),
        };
    };
    const onLoad = useCallback((map: google.maps.Map) => {
        mapRef.current = map;
        setMapsApi(window.google.maps)
        if (monthlyreport && monthlyreport.length > 0) {
            const bounds = new window.google.maps.LatLngBounds();
            monthlyreport.forEach((item: any) => {
                const lat = parseFloat(item.lat);
                const lng = parseFloat(item.long);
                if (!isNaN(lat) && !isNaN(lng)) {
                    bounds.extend({ lat, lng });
                }
            });
            map.fitBounds(bounds);
        }
    }, [monthlyreport]);

    useEffect(() => {
        setreportyear(dayjs(selectedMonth))
    }, [selectedMonth])

    const handledownloadExcel = async () => {
        try {
            const query = `?reportType=monthlySiteCore&clientEntityId=${storage.getItem(
                "clientEntityId"
            )}&year=${reportyear.year()}&month=${reportyear.month() + 1}&clientGroupName=${isGroupScore ? clientEntityIds : storage.getItem(
                "ClientGroupName"
            )}${selectedRegion ? `&regionId=${selectedRegion}` : ""}${(storage.getItem('areaId') || area) ? `&areaId=${area ?? storage.getItem('areaId')}` : ''}`;

            const response = await ApiDownloadExcel(query);

            // Create Excel blob
            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            if (blob.size === 0) {
                throw new Error("Empty Excel file.");
            }

            // Create download link
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;

            // Add a default filename
            link.setAttribute(
                "download",
                `MonthlyReport_${reportyear.year()}_${reportyear.month() + 1}.xlsx`
            );

            document.body.appendChild(link);
            link.click();

            // Clean up
            link.remove();
            URL.revokeObjectURL(url);
        } catch (error: any) {
            const message = error?.response?.message || error?.message;
            toast.error(message);
        }
    };
    const handleVenueDashboard = (venueId: string, venueName: string) => {
        if(!venueId){
            return
        }
        const url = `/maindashboard/sitedashboard?v=${encodeURIComponent(venueId)}&n=${encodeURIComponent(venueName)}&s=${encodeURIComponent(selectedMonth)}`;
        window.open(url, '_blank'); // opens in new tab
    };

    const handleOpenNewPage = (item: any, response: any) => {
        // Save the state temporarily (since navigate() can't pass state to a new tab)
        sessionStorage.setItem('viewScorecardData', JSON.stringify({
            item,
            htmlResponse: response?.data,
        }));

        // Open in a new tab
        window.open('/maindashboard/viewscorecard', '_blank');
    };
    const downloadScoreCard = async (item: any) => {
        try {
            const data = `?clientEntityId=${storage.getItem('clientEntityId')}&isClientEntityIdRequired=true&venueId=${item.venueId}&allocationId=${item.allocationId}&isHtmlContent=true${(storage.getItem('areaId')) ? `&areaId=${storage.getItem('areaId')}` : ''}`;
            const response = await ApiScoreCardPDF(data);
            // navigate('/maindashboard/viewscorecard', {state:{item:item, htmlResponse:response?.data}})

            handleOpenNewPage(item, response)
            // const blob = new Blob([response.data], { type: 'application/pdf' });
            // const url = window.URL.createObjectURL(blob);
            // const link = document.createElement('a');
            // link.href = url;

            // link.download = `ScoreCard_${item.venueId}_${item.allocationId}.pdf`;
            // document.body.appendChild(link);
            // link.click();

            // link.remove();
            // window.URL.revokeObjectURL(url);
        } catch (error) {
            alert(error);
        }

    }

    const fetchAreaManagers = async () => {
        try {
            const data = `?offset=0&limit=1000&clientEntityId=${isGroupScore ? clientEntityIds : clientEntity}`
            const response = await ApiGetAreaManager(data)
            setareamanagerlist(response.data)
        } catch (error) {
            console.error('Error fetching area managers:', error)
        }
    }
    useEffect(() => {
        clientEntity && fetchAreaManagers()
    }, [clientEntity, isGroupScore])
    console.log("region->", Regions)
    return (
        <Box className='mt-3'>
            <Box display={{ xs: 'flex', md: 'none' }} className='mb-0 justify-content-end align-items-center'>
                {window.location.hostname.includes('aldi') && (
                    <FormControl sx={{ width: 'fit-content', minWidth: '200px' }}>
                        <InputLabel id="demo-simple-select-label">Region: &nbsp;</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedRegion}
                            label='Region'
                            onChange={(e: any) => { setselectedRegion(e.target.value) }}
                        >
                            {Regions && Regions?.map((item: any, index: number) => (
                                <MenuItem key={index} value={item.regionId}>
                                    {item.regionName}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
                <Box maxWidth='140px' className='d-flex align-items-center justify-content-start'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker value={reportyear} className='month-select3'
                            views={['month', 'year']}
                            format="MMM-YYYY"
                            onChange={(e: any) => {
                                const isoString = e?.startOf('month').toISOString();
                                dispatch(setSelectedMonth(isoString));
                            }}

                            maxDate={dayjs()}
                            slots={{
                                openPickerIcon: ArrowDropDownIcon, // Replaces calendar icon
                            }}
                        />
                    </LocalizationProvider>
                </Box>
            </Box>

            <Box className='border-10 p-1'>
                <Box p={{ md: 3, xs: 2 }} pt={{ xs: "10px !important", md: '0px !important' }} className="d-flex  ps-0 flex-wrap  mb-0 justify-content-between align-items-center">
                    <Box className="text-left" width={{ xs: '100%', md: 'auto' }}>
                        <Typography fontSize='20px' fontWeight='bold' whiteSpace={{ xs: 'nowrap' }} className="font-bold" >Network Results</Typography>
                    </Box>
                    {(monthlyreport.length) > 0 && (
                        <Box mt={{ xs: 3, md: 0 }} className="selected   togglebutton  d-flex  justify-content-center mb-0">
                            <ToggleButtonGroup
                                className="d-flex justify-content-start m-0 p-0"
                                exclusive
                                value={alignment}
                                onChange={handleChange}
                            >
                                <Tooltip title={`Score < ${colorpalate[0]?.maxPercentage}%`}><ToggleButton className="m-0" sx={{ py: 1, px: { xs: 3, md: 3 }, whiteSpace: 'nowrap' }} value="red">
                                    Red
                                </ToggleButton></Tooltip>
                                <Tooltip title={`Score ${colorpalate[1]?.minPercentage}-${colorpalate[1]?.maxPercentage}%`}><ToggleButton sx={{ py: 1, px: { xs: 3, md: 3 }, whiteSpace: 'nowrap' }} className="m-0" value="yellow">
                                    Amber
                                </ToggleButton></Tooltip>
                                <Tooltip title={`Score > ${colorpalate[2]?.minPercentage}%`}><ToggleButton className="py-2 px-3 m-0" sx={{ py: 1, px: { xs: 3, md: 3 }, whiteSpace: 'nowrap' }} value="green">
                                    Green
                                </ToggleButton></Tooltip>

                            </ToggleButtonGroup>
                        </Box>
                    )}
                    {(storage.getItem("ClientGroupName") === "MM" || storage.getItem("ClientGroupName") ===  "EXTENDED" || storage.getItem("ClientGroupName") === "JBHIFI") && storage.getItem('userRole') === 'clientadmin' && (
                        <Box>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={isGroupScore}
                                        onChange={(e) => {setSelectedArea(null); setisGroupScore(e.target.checked)}}
                                    />
                                }
                                label={"Whole Group"}
                            />
                        </Box>)}
                    <Box display={{ xs: 'none', md: "flex" }} width='auto' gap={2} className='justify-content-end align-items-center'>
                        <Button className='btn-main px-3' onClick={() => { handledownloadExcel() }}>Download Excel</Button>
                        {window.location.hostname.includes('aldi') && (
                            <FormControl sx={{ width: 'fit-content', minWidth: '200px' }}>
                                <Autocomplete
                                    options={Regions || []}
                                    getOptionLabel={(option) => option.regionName || ''}
                                    value={Regions.find((item: any) => item.regionId === selectedRegion) || null}
                                    onChange={(event, newValue) => {
                                        setselectedRegion(newValue?.regionId || '');
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Region"
                                            variant="outlined"
                                            sx={{ input: { color: 'black' } }} // Ensures text is visible
                                        />
                                    )}
                                    isOptionEqualToValue={(option, value) => option.regionId === value.regionId}
                                />
                            </FormControl>
                        )}
                        {storage.getItem('userRole') === 'clientadmin' && storage.getItem('ClientGroupName') !== "ALDI" && (
                            <FormControl sx={{ width: 'fit-content', minWidth: '180px' }}>
                                {/* <InputLabel id="demo-simple-select-label" shrink={false}>Venues:</InputLabel> */}
                                <Autocomplete
                                    className='text-dark'
                                    options={Areamanagerlist || []}
                                    disabled={isGroupScore}
                                    getOptionLabel={(option) => option?.areaName || ''}
                                    value={Areamanagerlist?.find((item) => item.areaId === area) || null}
                                    onChange={(event, newValue) => {
                                        setSelectedArea(newValue?.areaId || '');
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Area" sx={{ color: 'black !important' }} variant="outlined" />
                                    )}

                                    isOptionEqualToValue={(option, value) => option.areaId === value.areaId}
                                />
                            </FormControl>
                        )}
                        <Box width={{ xs: '50%', md: 'fit-content' }} maxWidth='140px' className='d-flex align-items-center justify-content-start'>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker value={reportyear} className='month-select3'
                                    views={['month', 'year']}
                                    format="MMM-YYYY"
                                    onChange={(e) => {
                                        // setreportyear(newValue);
                                        const isoString: any = e?.startOf('month').toISOString();
                                        dispatch(setSelectedMonth(isoString));
                                    }} maxDate={dayjs()}
                                    slots={{
                                        openPickerIcon: ArrowDropDownIcon, // Replaces calendar icon
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Box>
                </Box>
                <Box position='relative' className='d-flex align-items-start gap-2'>
                    {isTransport !== 'TRANSPORT' && (<Box position='relative' className='col-md-6 col-12'>
                        {(monthlyreport?.length > 0 && (monthlyreport?.length) > 0) ? (
                            <LoadScript googleMapsApiKey="AIzaSyCmcI0swO1MNjQYUD7qktNT78-cDMBoi44">
                                <GoogleMap
                                    key={monthlyreport}
                                    onLoad={onLoad}
                                    onClick={() => setSelectedMarker(null)}
                                    mapContainerStyle={containerStyle} center={center} zoom={4}>
                                    {(monthlyreport && (monthlyreport?.length) > 0) && monthlyreport?.map((item: any, index: number) => {
                                        if (alignment === 'red' && item.finalScore < colorpalate[0]?.maxPercentage) {
                                            return (<Marker
                                                key={index}
                                                position={{ lat: parseFloat(item.lat), lng: parseFloat(item.long) }}
                                                onClick={() => setSelectedMarker(item)}
                                                icon={getMarkerIcon(parseFloat(item.finalScore))}



                                            />)
                                        }
                                        else if (alignment === 'yellow' && item.finalScore >= colorpalate[1]?.minPercentage && item.finalScore < colorpalate[1]?.maxPercentage) {
                                            return (<Marker
                                                key={index}
                                                position={{ lat: parseFloat(item.lat), lng: parseFloat(item.long) }}
                                                onClick={() => setSelectedMarker(item)}
                                                icon={getMarkerIcon(parseFloat(item.finalScore))}

                                            />)
                                        }
                                        else if (alignment === 'green' && item.finalScore >= colorpalate[2]?.minPercentage) {
                                            return (<Marker
                                                key={index}
                                                position={{ lat: parseFloat(item.lat), lng: parseFloat(item.long) }}
                                                onClick={() => setSelectedMarker(item)}
                                                icon={getMarkerIcon(parseFloat(item.finalScore))}

                                            />)
                                        }
                                    })}

                                    {selectedMarker && selectedMarker.lat && selectedMarker.long && (
                                        <InfoWindow
                                            position={{
                                                lat: parseFloat(selectedMarker.lat),
                                                lng: parseFloat(selectedMarker.long)
                                            }}
                                            onCloseClick={() => setSelectedMarker(null)}
                                        >
                                            <div className='m-0 p-0'>
                                                <p className='m-0 p-0'>{selectedMarker.venueName || "No Name"}</p>
                                            </div>
                                        </InfoWindow>
                                    )}
                                </GoogleMap>
                            </LoadScript>) : <Typography className='mx-auto text-center my-5' variant='h5'>No Data Found</Typography>}
                    </Box>)}
                    <Box className={`${isTransport === 'TRANSPORT' ? 'col-12' : 'col-md-6 col-12'}`} >

                        <Box className='mt-4'>
                            {(monthlyreport.length) > 0 && monthlyreport?.map((item: any, index: number) => {

                                if (alignment === 'red' && item.finalScore < colorpalate[0]?.maxPercentage) {
                                    red += 1;
                                    return (
                                        <Box onClick={() => { downloadScoreCard(item) }} sx={{ cursor: 'pointer' }} className='d-flex align-items-center mb-2 justify-content-between border border-10' key={index} px={2} py={1}>
                                            <Box> <Typography className='fw-bold' fontSize={{ xs: "18px", md: "20px" }}>{item.venueName} {item?.fleetNo ? `(FleetNo: ${item?.fleetNo})` : ''}</Typography></Box>
                                            <Box> <Typography className='fw-bolder' sx={{ color: '#BF613B' }} fontSize={{ xs: "20px", md: "24px" }}>{item.finalScore}</Typography></Box>
                                        </Box>

                                    )
                                }
                                else if (alignment === 'yellow' && item.finalScore >= colorpalate[1]?.minPercentage && item.finalScore < colorpalate[1]?.maxPercentage) {
                                    yellow += 1
                                    return (
                                        <Box onClick={() => { downloadScoreCard(item) }} sx={{ cursor: 'pointer' }} className='d-flex align-items-center mb-2 justify-content-between border border-10' key={index} px={2} py={{ xs: 1, md: 2 }}>
                                            <Box> <Typography className='fw-bold' fontSize={{ xs: "18px", md: "20px" }}>{item.venueName} {item?.fleetNo ? `(FleetNo: ${item?.fleetNo})` : ''}</Typography></Box>
                                            <Box><Typography className='fw-bolder' sx={{ color: 'rgb(192,153,82)' }} fontSize={{ xs: "20px", md: "24px" }}>{item.finalScore}</Typography></Box>
                                        </Box>

                                    )
                                }
                                else if (alignment === 'green' && item.finalScore >= colorpalate[2]?.minPercentage) {
                                    green += 1
                                    return (
                                        <Box onClick={() => { downloadScoreCard(item) }} sx={{ cursor: 'pointer' }} className='d-flex align-items-center mb-2 justify-content-between border border-10' key={index} px={2} py={{ xs: 1, md: 2 }}>
                                            <Box> <Typography className='fw-bold' fontSize={{ xs: "18px", md: "20px" }}>{item.venueName} {item?.fleetNo ? `(FleetNo: ${item?.fleetNo})` : ''}</Typography></Box>
                                            <Box><Typography className='fw-bolder' sx={{ color: '#ADB792' }} fontSize={{ xs: "20px", md: "24px" }}>{item.finalScore}</Typography></Box>
                                        </Box>

                                    )
                                }
                            })}
                            {((alignment == "red" && red == 0) || (alignment == "green" && green == 0) || (alignment == "yellow" && yellow == 0)) && (<Typography variant='h6' className='text-center w-100'>There are no sites with this traffic light score for this month</Typography>)}
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default GroupMonthlySiteScore
